import api from './api';

const service = {
    async algorithmRequest(params) {
        return await api.post(`/aggregators/${params.aggregator_id}/algorithm_request/dates/${params.date}/${params.kinds}/`, { bgroup_id: params.bgroup_id, pplant_id: params.pplant_id, area_id: params.area_id, time_code: params.time_code_id } );
    },
}

export default service;
